import DataGrid, { Column, FilterRow, Grouping, Selection } from "devextreme-react/data-grid";
import ScrollView from "devextreme-react/scroll-view";
import Switch from "devextreme-react/switch";
import Toolbar, { Item } from 'devextreme-react/toolbar';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { financeHelperApi } from "../../../../api/finance/financeHelperApi";
import RenderGroup from "../../../../components/cell-group";
import { DefaultButton, PrimaryButton } from '../../../../components/editor/button';
import TagBoxHinhThucNopBom from '../../../../components/editor/finance/TagBoxHinhThucNopBom';
import { showNotify } from '../../../../helpers/toast';


const TBTPCreateKhoanNopSelection = ({ ts_hocsinh, onCancel, onSelected, sf_tinhbaophi_khoandanops, sf_hinhthucnopbom_ids, sf_tinhbaophi_viewmodel }) => {
    const [is_tinh_mien_giam, set_is_tinh_mien_giam] = useState(true)
    const [isShowPlaceHolder, SetIsShowPlaceHolder] = useState(true)
    const [dataSource, setDataSource] = useState([]);

    const [sf_khoannops, set_sf_khoannops] = useState([]);
    const { dm_coso_id } = useSelector((x) => x.coSo);
    const { nam_hoc } = useSelector((x) => x.namHoc);
    const [sf_mucthuphi_datasource, set_sf_mucthuphi_datasource] = useState([])
    const [hinhThucNopBoms, setHinhThucNopBoms] = useState([]);

    const [sf_mucthuphi_selected_ids, set_sf_mucthuphi_selected_ids] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        handleReloadKhoanNops();
    }, [sf_khoannops == undefined || sf_khoannops.length == 0])
    useEffect(() => {
        handleReloadKhoanNop();
    }, [])
    useEffect(() => {
        handleReloadDataSource();
    }, [hinhThucNopBoms])
    const handleReloadKhoanNops = async () => {
        const res = await financeHelperApi.sf_khoannop_select_all()
        if (res.is_success) {
            set_sf_khoannops(res.data.data)
        }
    }
    const onSelectionChanged = ({ selectedRowKeys }) => {
        set_sf_mucthuphi_selected_ids(selectedRowKeys)
    }
    const handleReloadKhoanNop = async () => {
        setIsLoading(true)
        const res = await financeHelperApi.sf_mucphaithu_select_by_nam_nhap_hoc({
            dm_he_id: ts_hocsinh.dm_he_id,
            dm_khoi_id: ts_hocsinh.dm_khoi_id,
            dm_truong_id: ts_hocsinh.dm_truong_id,
            nam_hoc: ts_hocsinh.nam_hoc,
            nam_nhap_hoc: ts_hocsinh.nam_nhap_hoc == undefined ? nam_hoc : ts_hocsinh.nam_nhap_hoc
        })
        if (res.is_success) {
            let sf_mucthuphi_datasource = res.data.data.filter(x => x.nam_nhap_hoc == ts_hocsinh.nam_nhap_hoc).map(x => {
                return {
                    ...x,
                    so_tien_phai_nop: x.so_tien,
                    ghi_chu: ""
                }
            })
            if (sf_tinhbaophi_khoandanops !== undefined && sf_tinhbaophi_khoandanops.length > 0) {
                sf_mucthuphi_datasource = sf_mucthuphi_datasource.filter(x => !sf_tinhbaophi_khoandanops.includes(x.sf_khoannop_id));
            }
            if (!hinhThucNopBoms || hinhThucNopBoms.length === 0 || hinhThucNopBoms[0] === undefined) {
                set_sf_mucthuphi_datasource(sf_mucthuphi_datasource)
            }
            else {
                const xxx = new Set(hinhThucNopBoms.map(x => x.thangs).join(',').split(','));
                const _thangs = Array.from(xxx);
                let _khoanNops = sf_khoannops.filter(x => x.is_tao_trong_tbtp === true && _thangs.includes(x.thang.toString())).map(x => ({ ...x }))
                const maKhoanNopArray = _khoanNops.map(item => item.ma_khoan_nop);
                const filteredData = sf_mucthuphi_datasource.filter(x => maKhoanNopArray.includes(x.ma_khoan_nop));
                if (filteredData.length > 0) {
                    set_sf_mucthuphi_datasource(filteredData)
                }
                else {
                    set_sf_mucthuphi_datasource(sf_mucthuphi_datasource)
                }
            }
        }
        setIsLoading(false)
    }

    const IdxCellRender = useCallback(cell => {
        return <span>{cell.rowIndex + 1}</span>
    }, [])


    const handleReloadDataSource = async () => {
        setDataSource([])
        if (sf_tinhbaophi_khoandanops && dm_coso_id == 1) {
            const xxx = new Set(hinhThucNopBoms.map(x => x.thangs).join(',').split(','));
            const _thangs = Array.from(xxx);
            let _khoanNops = sf_khoannops.filter(x => x.is_tao_trong_tbtp === true && _thangs.includes(x.thang.toString())).map(x => ({ ...x }))
            // let _khoanNops = sf_khoannops.map(x => ({ ...x }))
            let _source = [];
            _khoanNops.forEach(khoanNop => {
                let _item = { ...khoanNop };
                const mucThuPhi = sf_mucthuphi_datasource.find(x => x.sf_khoannop_id == khoanNop.id);
                if (mucThuPhi) {
                    let isAdded = false;
                    hinhThucNopBoms.forEach(hinhThucNopBom => {
                        _item[`M_${hinhThucNopBom.id}`] = mucThuPhi.so_tien;
                        isAdded = true;
                    })
                    if (isAdded) {
                        _source.push(_item);
                    }
                }

            })
            setDataSource(_source);
        }
        else if (sf_tinhbaophi_khoandanops && hinhThucNopBoms[0] !== undefined && hinhThucNopBoms.length > 0) {
            const xxx = new Set(hinhThucNopBoms.map(x => x.thangs).join(',').split(','));
            const _thangs = Array.from(xxx);
            let _khoanNops = sf_khoannops.filter(x => x.is_tao_trong_tbtp === true && _thangs.includes(x.thang.toString())).map(x => ({ ...x }))
            let _source = [];
            _khoanNops.forEach(khoanNop => {
                let _item = { ...khoanNop };
                const mucThuPhi = sf_mucthuphi_datasource.find(x => x.sf_khoannop_id == khoanNop.id);
                if (mucThuPhi) {
                    let isAdded = false;
                    hinhThucNopBoms.forEach(hinhThucNopBom => {
                        //ca nam
                        if (hinhThucNopBom.id == 1) {
                            //không hiển thị các khoản sf_mucthuphi_canam_id>0
                            if (khoanNop.sf_khoannop_canam_id > 0) {
                                _item[`M_${hinhThucNopBom.id}`] = undefined;
                            } else {
                                _item[`M_${hinhThucNopBom.id}`] = mucThuPhi.so_tien;
                                isAdded = true;
                            }
                        } else {
                            // nếu hình thức nộp bom chứa tháng của khoản nộp thì show
                            if (hinhThucNopBom.thangs.split(',').includes(khoanNop.thang.toString())) {
                                //nếu có khoản nộp con sf_mucthuphi_canam_id mã đã show ở cột cả năm rồi thì thôi
                                if (_khoanNops.find(x => x.sf_khoannop_canam_id == khoanNop.id) && hinhThucNopBoms?.find(x => x.id == 1)) {
                                    _item[`M_${hinhThucNopBom.id}`] = undefined;
                                } else {
                                    _item[`M_${hinhThucNopBom.id}`] = mucThuPhi.so_tien;
                                    isAdded = true;
                                }
                            }
                        }
                    })
                    if (isAdded) {
                        _source.push(_item);
                    }
                }
            })
            setDataSource(_source);
        }
        else {
            setDataSource([])
        }
    }
    const handleSubmit = async () => {
        setIsLoading(true);
        const res = await financeHelperApi.sf_tinhbaophi_insert({
            is_calculate_miengiam: is_tinh_mien_giam,
            nam_hoc: nam_hoc,
            sf_hinhthucnopbom_id: 0,
            sf_hinhthucnopbom_ids: hinhThucNopBoms.map(x => x.id).join(","),
            sf_khoannops: sf_mucthuphi_selected_ids.map(x => ({
                sf_khoannop_id: x
            })),
            ts_hocsinh_id: ts_hocsinh.id,
            sf_tinhbaophi_id: sf_tinhbaophi_viewmodel !== undefined ? sf_tinhbaophi_viewmodel.id : 0
        });
        setIsLoading(false);
        onSelected();
        if (res.is_success) {
            showNotify({ text: "Cập nhật báo phí thành công", type: "success" });
        } else {
            showNotify({ text: "Cập nhật báo phí không thành công", type: "error" })
        }
    }
    return (
        <Modal
            open={true}
            dimmer={'blurring'}
            closeOnEscape={false}
            closeOnDimmerClick={false}
            size="large"

        >
            <Modal.Header>
                <div className="label">{`${ts_hocsinh.ma_hs} - ${ts_hocsinh.ho_ten} - Tính báo phí`}</div>
            </Modal.Header>
            <Modal.Content>
                <div className="row">
                    <Toolbar className='bg-background'>
                        <Item
                            location='before'
                            render={() => {
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ fontWeight: 'bold', marginLeft: 10 }}>Tự động tính miễn giảm </label>
                                        <Switch value={is_tinh_mien_giam}
                                            className="margin-top-10px margin-left-10px"
                                            onValueChanged={(e) => {
                                                set_is_tinh_mien_giam(e.value)
                                            }}
                                        />
                                    </div>
                                );
                            }}
                        />
                        <Item
                            location='before'
                            render={() => {
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ fontWeight: 'bold', marginLeft: 10 }}>Chọn kỳ nộp </label>
                                        <TagBoxHinhThucNopBom
                                            isShowClearButton={true}
                                            width={400}
                                            stylingMode="filled"
                                            value={hinhThucNopBoms.map(x => x.id)}
                                            onValueChanged={(id, data) => {
                                                setHinhThucNopBoms(data);
                                            }}
                                        />
                                    </div>
                                );
                            }}
                        />
                        {/* <Item
                            location='before'
                            render={() => {
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ fontWeight: 'bold', marginLeft: 20 }}>Tổng tiền phải nộp: {summary?.toLocaleString()} </label>
                                    </div>
                                );
                            }}
                        /> */}
                    </Toolbar>
                </div>
                <ScrollView width={"100%"} height={window.innerHeight - 250}>
                    <div>
                        <div className="row">
                            <div className="col-md-12">
                                <DataGrid

                                    keyExpr="id"
                                    dataSource={dataSource}
                                    columnHidingEnabled={false}
                                    columnAutoWidth={true}
                                    showBorders={true}
                                    showColumnLines={true}
                                    showRowLines={true}
                                    rowAlternationEnabled={true}
                                    allowColumnResizing={true}
                                    columnResizingMode={"nextColumn"}
                                    hoverStateEnabled={true}
                                    focusedRowEnabled={true}
                                    height={window.innerHeight - 170}
                                    selectedRowKeys={sf_mucthuphi_selected_ids}
                                    onSelectionChanged={({ selectedRowKeys, selectedRowsData }) => {
                                        set_sf_mucthuphi_selected_ids(selectedRowKeys);
                                    }}
                                    wordWrapEnabled={true}
                                    loadPanel={{ enabled: false }}
                                    paging={{ enabled: false }}

                                >
                                    <Selection
                                        mode={"multiple"}
                                        selectAllMode={"allPages"}
                                        showCheckBoxesMode={"always"}
                                    />
                                    <Grouping autoExpandAll={false} />
                                    <FilterRow visible={true} />
                                    <Column visibleIndex={0} caption={"#"} cellRender={IdxCellRender} width={40} alignment="center" autoExpandGroup={false} />
                                    <Column dataField="nhom_khoan_nop" groupCellRender={e => <RenderGroup
                                        e={e}
                                        selectedIds={sf_mucthuphi_selected_ids}
                                        onSelectedChanged={set_sf_mucthuphi_selected_ids}
                                    />} caption="Nhóm" groupIndex={0} allowEditing={false} ></Column>
                                    <Column dataField="ma_khoan_nop" caption="Mã khoản nộp" width={150}></Column>,
                                    <Column dataField="ten_khoan_nop" caption="Tên khoản nộp" ></Column>,
                                    {hinhThucNopBoms && hinhThucNopBoms.map((x) => {
                                        return (
                                            <Column key={x.id} caption={x.name} dataField={`M_${x.id}`} format={",##0"} />
                                        );
                                    })}
                                </DataGrid>
                            </div>
                        </div>
                    </div>

                </ScrollView>
            </Modal.Content>
            <Modal.Actions>
                <DefaultButton type="normal" text="Đóng" onClick={() => { onCancel() }} /> {' '}
                <PrimaryButton type="success" text="Áp dụng"
                    isLoading={isLoading}
                    isDisabled={sf_mucthuphi_selected_ids.length === 0}
                    onClick={handleSubmit}
                />
            </Modal.Actions>
        </Modal>
    );
};

export default TBTPCreateKhoanNopSelection;